<template>
  <v-dialog v-model="visible" persistent max-width="800px">
    <v-card>
      <v-card-title>
        <v-spacer></v-spacer>
        <v-icon large @click="close()">mdi-close</v-icon>
      </v-card-title>
      <v-card-text>
        <v-container>
          <v-row>
            <v-col cols="12" sm="12" md="8">
              <h1 class="text-h5 font-weight-regular pb-4">
                {{ $t("accounts.editAccount") }}
              </h1>
              <p class="py-5">
                {{ $t("accounts.editAccountMessage") }}
              </p>
              <v-row>
                <v-col cols="12" sm="12" md="6">
                  <label class="second-type-label">{{ $t("accounts.accountNumber") }}</label>
                  <p class="font-weight-medium">{{ account.iban }}</p>
                </v-col>
                <v-col :hidden="account.bic === ''" cols="12" sm="12" md="6">
                  <label class="second-type-label">{{ $t("accounts.bic") }}</label>
                  <p class="font-weight-medium">{{ account.bic }}</p>
                </v-col>
              </v-row>
              <label class="second-type-label">{{ $t("accounts.description") }}</label>
              <v-text-field
                v-model="account.description"
                dense
                max="30"
                maxlength="30"
                counter
                outlined
                :color="entityConfig.primaryColor"
              ></v-text-field>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
      <v-card-actions class="card-action-with-space">
        <v-spacer></v-spacer>
        <v-btn
          outlined
          class="v-btn-width-default"
          :color="entityConfig.primaryColor"
          @click="$emit('closed')"
        >
          {{ $t("accounts.goBack") }}
        </v-btn>
        <v-btn
          dark
          depressed
          class="v-btn-width-default"
          :color="entityConfig.primaryColor"
          :style="`color: ${entityConfig.secondaryColor}`"
          @click="edit_account"
        >
          {{ $t("accounts.modify") }}
        </v-btn>
      </v-card-actions>
    </v-card>
    <overlay :visible="spinner" :opacity="1"></overlay>
  </v-dialog>
</template>

<script>
import Overlay from "../../components/layouts/overlay.vue";
import Api from "../../Services/index";
export default {
  props: ["account", "visible"],
  components: {
    Overlay,
  },
  data() {
    return {
      entityConfig: {},
      spinner: false,
      userId: "",
      userdata: {},
      model: {
        iban: "",
        description: "",
        bic: "",
      },
    };
  },
  mounted() {
    this.entityConfig = this.$store.state.entityConfig.config;
    Api.defaults.headers.common["Authorization"] =
      "Bearer " + sessionStorage.getItem("authtoken");
    this.userdata = JSON.parse(sessionStorage.getItem("userData"));
    this.userId = this.userdata.supplierId.trim();
    this.model.iban = this.account.iban;
    this.model.description = this.account.description;
    this.model.bic = this.account.bic;

    let editAccount = JSON.parse(sessionStorage.getItem("accountConfirmEdit"));
    if (editAccount) {
      this.model = editAccount;
    }
  },
  methods: {
    close() {
      this.$emit("closed");
    },
    save(data) {
      this.$emit("saved", data);
    },

    edit_account(data) {
      try {
        this.spinner = true;
        const formData = new FormData();
        formData.append("iban", this.account.iban);
        formData.append("bic", this.model.bic);
        formData.append("description", this.account.description);
        formData.append("bic", this.account.bic);

        Api.defaults.headers.common["Authorization"] =
          "Bearer " + sessionStorage.getItem("authtoken");
        const obj = Object.fromEntries(formData);
        sessionStorage.setItem("accountConfirmEdit", JSON.stringify(obj));
        this.spinner = false;
        this.$emit("saved", data);
        this.$emit("closed");

        this.$router.push({ path: "/cuentas-de-abono/confirmar/edit" });
      } finally {
        this.spinner = false;
      }
    },
  },
};
</script>
